import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../_shared/shared.module';
import { NgxsModule } from '@ngxs/store';
import { InfoState } from './state/info.state';
import { CommentsState } from './state/comments/comments.state';
import { CommentComponent } from './components/comments/comment/comment.component';
import { EditCommentComponent } from './components/comments/edit-comment/edit-comment.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { CommentSkeletonComponent } from './components/comments/comment-skeleton/comment-skeleton.component';


@NgModule({
  declarations: [
    CommentComponent,
    EditCommentComponent,
    CommentSkeletonComponent,
  ],
  imports: [
    CommonModule,
    // InfoRoutingModule, TODO uncomment when info page is migrated
    NgxsModule.forFeature([InfoState, CommentsState]),
    SharedModule,
    FormsModule,
    TranslateModule,
    ReactiveFormsModule,
  ],
  exports: [
    CommentComponent,
    CommentSkeletonComponent,
    EditCommentComponent,
  ],
})
export class InfoModule { }
